import uuid from '~/common/uuid'
import { avatarStyles } from '~/common/avatars'

const { FRIENDLY, BUSINESS } = avatarStyles

export const previewPlayers = [
  {
    id: uuid(),
    name: 'Sample Player',
    avatar: {
      [BUSINESS]: '/emoji-business/like.svg',
      [FRIENDLY]: '/emoji/1f602.svg'
    }
  },
  {
    id: uuid(),
    name: 'Sample',
    avatar: {
      [BUSINESS]: '/emoji-business/briefcase.svg',
      [FRIENDLY]: '/emoji/1f63b.svg'
    }
  },
  {
    id: uuid(),
    name: 'Sample Name',
    avatar: {
      [BUSINESS]: '/emoji-business/tie.svg',
      [FRIENDLY]: '/emoji/1f951.svg'
    }
  },
  {
    id: uuid(),
    name: 'Sample Player...',
    avatar: {
      [BUSINESS]: '/emoji-business/trophy.svg',
      [FRIENDLY]: '/emoji/1f929.svg'
    }
  },
  {
    id: uuid(),
    name: 'Sample',
    avatar: {
      [BUSINESS]: '/emoji-business/shooting-star.svg',
      [FRIENDLY]: '/emoji/1f680.svg'
    }
  }
]
